<template>
  <div class="col-xs-12">
    <div id="customers-panel" class="panel panel-primary">
      <div class="panel-heading" style="text-align: left">
        Create New Discount
      </div>
      <form @submit.prevent="submitDiscountForm">
        <div class="panel-body">
          <div
            class="form-group"
            :class="codeDiscExist ? 'has-error has-feedback' : ''"
          >
            <label class="control-label">Discount Code*</label>
            <input
              class="form-control"
              type="text"
              name="code"
              required
              @change="handleDiscountCode($event)"
            />
            <span
              v-if="codeDiscExist"
              class="glyphicon glyphicon-remove form-control-feedback"
            ></span>
            <span v-if="codeDiscExist" class="help-block">
              Please select a different Code.
            </span>
            <span class="help-block">Unique identifier for this discount</span>
          </div>

          <div class="form-group">
            <label class="control-label">Discount Name*</label>
            <input
              v-model="name"
              class="form-control"
              type="text"
              name="name"
              value=""
              required
            />
          </div>

          <div class="form-group">
            <label class="control-label">Discount Amount*</label>
            <div class="input-group">
              <span class="input-group-addon">
                <span class="glyphicon glyphicon-usd"></span>
              </span>
              <input
                class="form-control"
                type="number"
                min="0"
                name="base_price"
                value=""
                required
                @change="handleBasePrice($event)"
              />
            </div>
          </div>

          <div class="form-group">
            <label class="control-label">Discount Duration*</label>
            <input
              v-model="duration"
              class="form-control"
              type="number"
              name="duration"
              value=""
              required
            />
          </div>

          <div class="form-group">
            <label class="control-label">Description*</label>
            <input
              v-model="description"
              class="form-control"
              type="text"
              name="description"
              value=""
              required
            />
          </div>

          <div class="form-group">
            <label for="locale_id">Locale*</label>
            <select
              id="locale_id"
              v-model="locale_id"
              type="text"
              name="locale_id"
              class="form-control"
              required
            >
              <option
                v-for="locale in locales"
                :key="'locale-' + locale.id"
                :value="locale.id"
              >
                {{ locale.country }}
              </option>
            </select>
          </div>
          <div class="form-group">
            <label class="checbox">
              <input
                :checked="legacyValue"
                type="checkbox"
                name="legacy"
                :value="legacyValue"
                @change="handleLegacyCheckBox($event)"
              />
              Legacy Discount
            </label>
          </div>
        </div>

        <!-- ====== ECLIPSE PRODUCTS ====== -->
        <hr />
        <div class="form-group" :class="legacyValue ? 'hide' : ''">
          <label class="control-label">Eclipse Product Data</label>
          <div class="well">
            <div class="row">
              <div class="form-group col-xs-6" style="margin-bottom: 0">
                <label class="control-label">Product*</label>
              </div>

              <div
                v-for="(eclipseProduct, index) in eclipseProducts"
                :key="eclipseProduct.product_name"
                class="eclipse_product_container"
              >
                <button
                  v-if="index > 0"
                  class="close"
                  type="button"
                  style="padding-right: 15px; padding-bottom: 5px"
                  @click="removeProduct(index)"
                >
                  <span aria-hidden="true">x</span>
                </button>

                <div class="form-group col-xs-12">
                  <input
                    autocomplete="off"
                    type="text"
                    name="eclipse_product[]"
                    :value="eclipseProduct.product_name"
                    class="form-control"
                    @click="
                      modal(true, 'eclipseProduct', 'Search Eclipse Product');
                      setIndexModal(index);
                    "
                  />
                </div>
                <div class="form-group col-xs-12">
                  <select
                    class="form-control"
                    name="product_implementation"
                    required
                    @change="handleUpdateTotal($event, index)"
                  >
                    <option value="">-- Select Implementation --</option>
                    <option value="ces">CES</option>
                    <option value="var">VAR</option>
                  </select>
                </div>

                <div class="eclipse_sub_cyclesX">
                  <div class="form-group col-xs-6">
                    <input
                      class="form-control"
                      type="number"
                      name="product_cycle_start"
                      min="1"
                      placeholder="Cycle Start..."
                      @change="handleUpdateTotal($event, index)"
                    />
                  </div>
                  <div class="form-group col-xs-6">
                    <input
                      class="form-control"
                      type="number"
                      name="product_cycle_end"
                      min="1"
                      placeholder="Cycle End..."
                      @change="handleUpdateTotal($event, index)"
                    />
                  </div>
                </div>

                <div class="form-group col-xs-12">
                  <div class="row">
                    <div class="form-group col-xs-12 col-sm-6">
                      <label>Customer Discount</label>
                      <div class="input-group">
                        <span class="input-group-addon">
                          <span class="glyphicon glyphicon-usd"></span>
                        </span>
                        <input
                          class="form-control"
                          type="text"
                          name="cycle_cost_unused"
                          step="0.01"
                          :value="eclipseProduct.cycle_cost_unused"
                          disabled
                        />
                      </div>
                    </div>

                    <div class="form-group col-xs-12 col-sm-6">
                      <label>Vendor Deduction</label>
                      <div class="input-group">
                        <span class="input-group-addon">
                          <span class="glyphicon glyphicon-usd"></span>
                        </span>
                        <input
                          class="form-control"
                          type="number"
                          name="vendor_cost_unused[]"
                          step="0.01"
                          :value="
                            formatAmount(eclipseProduct.vendor_cost_unused)
                          "
                          disabled
                        />
                      </div>
                    </div>

                    <div class="form-group col-xs-12 col-sm-4">
                      <label>eDist Deduction</label>
                      <div class="input-group">
                        <span class="input-group-addon">
                          <span class="glyphicon glyphicon-usd"></span>
                        </span>
                        <input
                          class="form-control"
                          type="number"
                          name="edist_cut"
                          step="0.01"
                          value="0"
                          @change="handleUpdateTotal($event, index)"
                        />
                      </div>
                    </div>

                    <div class="form-group col-xs-12 col-sm-4">
                      <label>Var Deduction</label>
                      <div class="input-group">
                        <span class="input-group-addon">
                          <span class="glyphicon glyphicon-usd"></span>
                        </span>
                        <input
                          class="form-control"
                          type="number"
                          name="var_cut"
                          step="0.01"
                          value="0"
                          @change="handleUpdateTotal($event, index)"
                        />
                      </div>
                    </div>

                    <div class="form-group col-xs-12 col-sm-4">
                      <label>CESC Deduction</label>
                      <div class="input-group">
                        <span class="input-group-addon">
                          <span class="glyphicon glyphicon-usd"></span>
                        </span>
                        <input
                          class="form-control"
                          type="number"
                          name="ces_cut"
                          step="0.01"
                          value="0"
                          @change="handleUpdateTotal($event, index)"
                        />
                      </div>
                    </div>

                    <div class="clearfix"></div>
                  </div>
                </div>

                <div class="clearfix"></div>
                <hr />
                <div class="clearfix"></div>
                <div>
                  <div class="col-xs-12">
                    <button
                      type="button"
                      class="btn btn-primary"
                      @click="addEclipseProduct()"
                    >
                      + Add Another Product
                    </button>
                  </div>
                  <div class="col-xs-12">
                    <hr />
                  </div>
                  <div class="col-xs-12">
                    <span class="help-block">
                      Deductions will be subtracted from the cycle costs of the
                      bundle the discount is applied to
                    </span>
                  </div>
                </div>
                <div class="clearfix"></div>
              </div>
            </div>
          </div>
        </div>
        <div class="panel-footer">
          <button id="form_submit" type="submit" class="btn btn-primary">
            <span v-if="loadingSubmit == null || loadingSubmit === false">
              Submit
            </span>
            <span v-else-if="loadingSubmit === true">Processing...</span>
          </button>
        </div>
      </form>

      <modal v-if="modalId === 'eclipseProduct'" :show-modal="showModal">
        <eclipse-product-search></eclipse-product-search>
      </modal>
    </div>
  </div>
</template>

<script>
import EclipseProductSearch from "../forms/eclipseProductSearch.vue";
import Modal from "../../../Modal.vue";

export default {
  components: {
    EclipseProductSearch,
    Modal,
  },
  data() {
    return {
      locale_id: 1,
      name: "",
      duration: "",
      description: "",
    };
  },
  computed: {
    locales() {
      return this.$store.state.dic.locales;
    },
    codeDiscExist() {
      return this.$store.state.discount.code_exist;
    },
    codeDiscount() {
      return this.$store.state.discount.code;
    },
    eclipseProducts() {
      return this.$store.state.product.eclipse_products;
    },
    showModal() {
      return this.$store.state.dic.show_modal;
    },
    modalId() {
      return this.$store.state.dic.modal_id;
    },
    subscriptionValue() {
      return this.$store.state.product.subscription_value;
    },
    basePrice() {
      return this.$store.state.product.product_base_price;
    },
    groupEclipseProductId() {
      return this.$store.state.product.group_eclipse_product_id;
    },
    groupEclipseProductName() {
      return this.$store.state.product.group_eclipse_product_name;
    },
    groupEclipseProductImplementation() {
      return this.$store.state.product.group_eclipse_product_implementation;
    },
    groupEclipseProductCycleStart() {
      return this.$store.state.product.group_eclipse_product_cycle_start;
    },
    groupEclipseProductCycleEnd() {
      return this.$store.state.product.group_eclipse_product_cycle_end;
    },
    groupEclipseCycleCostUnused() {
      return this.$store.state.product.group_eclipse_product_cycle_cost_unused;
    },
    groupEclipseVendorCostUnused() {
      return this.$store.state.product.group_eclipse_product_vendor_cost_unused;
    },
    groupEclipseEdistCut() {
      return this.$store.state.product.group_eclipse_product_edist_cut;
    },
    groupEclipseVarCut() {
      return this.$store.state.product.group_eclipse_product_var_cut;
    },
    groupEclipseCesCut() {
      return this.$store.state.product.group_eclipse_product_ces_cut;
    },
    loadingSubmit() {
      return this.$store.state.discount.loading_submit;
    },
    legacyValue() {
      return this.$store.state.discount.legacy_checkbox;
    },
  },
  created() {
    this.$store.dispatch("getLocales", null, { root: true });
  },
  mounted() {
    this.$store.dispatch("setInitialProduct");
  },
  methods: {
    submitDiscountForm() {
      this.$store.dispatch("groupEclipseProductData");
      const formFields = this.getFormFields();
      this.$store.dispatch("submitAddNewDiscountForm", formFields);
    },
    getFormFields() {
      return {
        code: this.codeDiscount,
        name: this.name,
        base_price: this.basePrice,
        duration: this.duration,
        description: this.description,
        locale_id: this.locale_id,
        eclipse_product: this.groupEclipseProductId,
        eclipse_product_name: this.groupEclipseProductName,
        product_implementation: this.groupEclipseProductImplementation,
        product_cycle_start: this.groupEclipseProductCycleStart,
        product_cycle_end: this.groupEclipseProductCycleEnd,
        edist_cut: this.groupEclipseEdistCut,
        var_cut: this.groupEclipseVarCut,
        ces_cut: this.groupEclipseCesCut,
        legacy: this.legacyValue,
      };
    },
    handleDiscountCode(event) {
      this.$store.dispatch("setDiscCode", event.target.value);
      this.$store.dispatch("checkDiscCode");
    },
    addEclipseProduct() {
      this.$store.dispatch("addNewEclipseProduct");
    },
    modal(modalState, modalId, modalTitle) {
      this.$store.dispatch("clearEclipseSearchResults");
      this.$store.dispatch("setModal", {
        modal_id: modalId,
        modal_title: modalTitle,
      });
      this.$store.dispatch("setModalState", modalState);
    },
    formatAmount(value) {
      return value.toFixed(2);
    },
    setIndexModal(index) {
      this.$store.dispatch("setIndexModal", index);
    },
    removeProduct(index) {
      this.$store.dispatch("removeProduct", index);
    },
    handleBasePrice(event) {
      this.$store.dispatch("setBasePrice", event.target.value);
      this.$store.dispatch("updateTotals");
    },
    handleUpdateTotal(event, index) {
      const field = event.target.getAttribute("name");
      const { value } = event.target;

      switch (field) {
        case "edist_cut":
          this.$store.dispatch("setEdistCutValue", {
            value,
            index,
          });
          break;
        case "var_cut":
          this.$store.dispatch("setVarCutValue", {
            value,
            index,
          });
          break;
        case "ces_cut":
          this.$store.dispatch("setCesCutValue", {
            value,
            index,
          });
          break;
        case "product_implementation":
          this.$store.dispatch("setProdImplementationValue", {
            value,
            index,
          });
          break;
        case "product_cycle_start":
          this.$store.dispatch("setProdCycleStart", {
            value,
            index,
          });
          break;
        case "product_cycle_end":
          this.$store.dispatch("setProdCycleEnd", {
            value,
            index,
          });
          break;
        default:
          return;
      }

      this.$store.dispatch("updateTotals");
    },
    handleLegacyCheckBox(event) {
      this.$store.dispatch("setLegacyCheckbox", event.target.value);
    },
  },
};
</script>
